"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInnerBorderRadius = void 0;
/**
 * Based on https://www.w3.org/TR/css-backgrounds-3/#corners
 * "The padding edge (inner border) radius is the outer border radius minus the
 * corresponding border thickness."
 */
function getInnerBorderRadius(borderRadius, borderWidth) {
    var numericWidth = +borderWidth.replace('px', '');
    if (isNaN(numericWidth)) {
        return borderRadius;
    }
    function getInner(value) {
        var numeric = value - numericWidth;
        return numeric > 0 ? numeric : 0;
    }
    var innerRadiusParts = [];
    for (var _i = 0, _a = borderRadius.split(' '); _i < _a.length; _i++) {
        var part = _a[_i];
        var value = +part.replace('px', '');
        if (isNaN(value)) {
            return borderRadius;
        }
        innerRadiusParts.push(getInner(value) + "px");
    }
    return innerRadiusParts.join(' ');
}
exports.getInnerBorderRadius = getInnerBorderRadius;
//# sourceMappingURL=helpers.js.map